import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { TranslateService } from '@ngx-translate/core'

@Injectable({ providedIn: 'root' })
export class MessageService {
    constructor(private toastr: ToastrService, private translate: TranslateService) {}
    addMessage(message: {
        severity: 'error' | 'success' | 'info' | 'warn'
        message: string
        detail?: string
        icon?: string
    }) {
        const severity = message.severity || 'info'
        message.message = this.translate.instant(message.message)
        message.detail = message.detail && this.translate.instant(message.detail)
        switch (severity.toLowerCase()) {
            case 'error':
                this.toastr.error(message.detail, message.message)
                break
            case 'success':
                this.toastr.success(message.detail, message.message)
                break
            case 'info':
                this.toastr.info(message.detail, message.message)
                break
            case 'warn':
                this.toastr.warning(message.detail, message.message)
                break
            default:
                this.toastr.show(message.detail, message.message)
                break
        }
    }
}
